import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import {
  Box,
  Button,
  TextField,
  Alert,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Stack
} from "@mui/material";
import type { ResetPasswordData, User } from "@/api/user.service"
import { resetPassword } from "@/api/user.service";
import { useNotification } from "@/context/NotificationContext";

export const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { notify } = useNotification();

  const token = searchParams.get('token');

  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/login";

  const handleNewPassword = async (e: React.SubmitEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    if (password !== confirmPassword) {
      setError("As senhas devem ser iguais");
      setLoading(false);
      return
    }

    if (token == null) {
      navigate(from, { replace: true });
      return;
    }

    var user: ResetPasswordData = {
      token,
      password
    };

    try {
      await resetPassword(user);
      notify("Senha alterado com sucesso! Redirecionando para login", "success")

      setTimeout(() => {
        navigate(from, { replace: true });
      }, 2000)
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message);
      } else {
        setError("Erro inesperado. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token == null)
      navigate(from, { replace: true });
  }, [token])

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
      px={2}
    >
      <Card sx={{ width: { xs: '100%', sm: 400 }, maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.12)', border: 'none' }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" mb={2} textAlign="center">
            Nova Senha
          </Typography>

          <Box component="form" onSubmit={handleNewPassword}>
            <Stack spacing={2}>
              {error && (
                <Alert severity="error">
                  {error}
                </Alert>
              )}

              <TextField
                label="Senha"
                type="password"
                required
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <TextField
                label="Confirmar Senha"
                type="password"
                required
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                disabled={loading}
              >
                {loading ? <CircularProgress size={22} /> : "Enviar"}
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
